@if (isGoogleMapsLoaded) {
    <div class="w-100 h-100 map col-12 px-0 google-map">
        @if (markersList.length) {
            <google-map [width]="'100%'" [height]="'100%'" [mapId]="googleMapId" [options]="mapOptionsConfig">
                @for (marker of markersList; let markerIndex = $index; track markerIndex) {
                    @if (marker.position) {
                        <map-advanced-marker
                            [position]="marker.position"
                            [title]="marker.title"
                            [gmpDraggable]="marker.gmpDraggable || false"
                            [options]="{ gmpClickable: marker.gmpClickable }"
                            (mapClick)="openInfoWindow(marker, markerIndex)"
                            [content]="advancedMarkerContent"
                        >
                            <img #advancedMarkerContent [src]="markers[markerIndex].icon" [alt]="markers[0].title" />
                        </map-advanced-marker>
                        <map-info-window>{{ infoLabel }}</map-info-window>
                    }
                }
            </google-map>
        }
    </div>
} @else {
    @if (isLoadingGoogleMaps) {
        <div class="d-flex h-100 w-100 justify-content-center align-items-center">
            <mat-spinner matPrefix diameter="24" class="me-2" />
        </div>
    }
    @if (!isLoadingGoogleMaps) {
        <div class="d-flex h-100 w-100 justify-content-center align-items-center not-available-map-content">
            <mat-icon>sentiment_dissatisfied</mat-icon>
            <h2 class="mat-headline-6 m-0 px-0 headline">Sorry, the maps are currently not available.</h2>
            <div class="mat-caption help-caption px-0 body-2">
                Please try again, or contact our Support Team for assistance
            </div>
        </div>
    }
}
